import "@fontsource/poppins"; // Defaults to 400 weight
import "@fontsource/poppins/500.css"; // If you want a specific weight

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/home';
import ServicesPage from './components/Services'
import AboutUs from './components/AboutUs';



function App() {
  return (
    <Router >
      <Routes>
        {/* Route for the home page */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/aboutus" element={<AboutUs />} />


        {/* Other routes can be added here */}
      </Routes>
    </Router>
  );
}

export default App;
